import React from "react";
import PolicyPage from "./PolicyPage";
import { STORE } from "../config/store";

const sections = [
  {
    title: "Cross-border scope",
    paragraphs: [`These cross-border rules begin when a parcel leaves the ${STORE.operatingRegion} operation for another customs territory. The live checkout selector controls which destinations accept an order attempt. Being able to choose a place does not cancel an import control applied there.`],
  },
  {
    title: "Charges shown by this shop",
    paragraphs: [`The ${STORE.currency} checkout total contains the merchandise subtotal and fixed ${STORE.currency} ${STORE.shippingFee.toFixed(2)} delivery charge. A duty, import tax, brokerage, customs storage or destination-handling amount is part of this store's charge only if it is expressly itemised in the checkout total.`],
  },
  {
    title: "Destination assessment",
    paragraphs: ["Authorities and delivery services can examine goods and request information from the recipient. The recipient is responsible for completing a lawful destination request and paying a destination charge lawfully assessed to them. Rates are not stated here because they depend on the goods and destination at the time of entry."],
  },
  {
    title: "Product restrictions",
    paragraphs: ["Body oils, lotions, bath preparations, modelling dough, jewellery materials, wooden or paper goods and children's products can be subject to destination-specific controls. A restricted item may be removed before acceptance or the order may be cancelled if lawful delivery cannot proceed. Customers should check destination rules that apply to the intended use before ordering."],
  },
  {
    title: "Border delay and non-clearance",
    paragraphs: ["Customs review can extend an order-specific estimate. If a parcel cannot be cleared, customer service reviews the reason, parcel status, product condition, charges and applicable rights before confirming the financial outcome. A refusal to provide required destination information is assessed differently from a store error or a product that could not lawfully be sent."],
  },
  {
    title: "Damage, loss and rights",
    paragraphs: ["Cross-border status does not remove the package evidence process or compulsory consumer rights. Report loss, leakage, breakage or incorrect contents under the package policy and preserve the border or delivery correspondence with the item and packaging."],
    links: [["Lost, Delayed & Damaged Packages", "/package-issues"]],
  },
];

export default function InternationalOrders() {
  return <PolicyPage title="International Orders & Customs" intro="Checkout charges, destination responsibility and border issues for cross-border physical goods." sections={sections} related={[["Shipping & Delivery", "/shipping"], ["Product Safety & Care", "/product-safety"]]} />;
}
